import { Button, Dropdown, Menu, Pagination, Select, Tooltip } from 'antd';
import React, { Component } from 'react';
import ChannelTable from '../channel-table';
import lang from './../../../../../languages/en';
import deleteDisable from './../../../../../resources/assets/images/deleteDisable.png';
import deleteEnable from './../../../../../resources/assets/images/deleteEnable.png';
import filterDisabled from './../../../../../resources/assets/images/filter.png';
import filterEnabled from './../../../../../resources/assets/images/filterEnable.png';
import prohibited from './../../../../../resources/assets/images/prohibited.png';
import iconImportAmazon from './../../../../../resources/assets/images/import_file_item_master.png';
import { showConfirm } from './../../../../../services/dialog';
import saveItemMaster from './../../../../../resources/assets/images/save_item_master.png'
import handlePermission from './../../../../app/handlePermission';
import iconMore from './../../../../../resources/assets/images/more_item_master.png'
import { permissions } from '../../../../../constants';
import history from './../../../../../services/history';
const { Option } = Select

class ToolbarItemMaster extends Component {
    render() {
        let is_show_btn_more = handlePermission(permissions.ItemNameExport) && handlePermission(permissions.ItemNameUpdateItemName);
        let { LineNumberItemname } = this.props;
        const menuImportOrder = (
            <Menu>
                <Menu.Item key="1" onClick={this.props.exportFile}>Export File</Menu.Item>
                <Menu.Item key="2" onClick={this.props.deleteDatabase} disabled={!handlePermission(permissions.ItemNameUpdateItemName)}>Reset Item Master</Menu.Item>
            </Menu>
        )

        return (
            <React.Fragment>
                {
                    handlePermission(permissions.ItemNameUpdateItemName) ?
                        <span className="icon-save-file">
                            <Tooltip placement="top" title="Save Item">
                                <Button
                                    onClick={() => this.props.saveItemName()}
                                    disabled={!this.props.isEdit}
                                >
                                    <img id='save-item-master' src={saveItemMaster} style={!this.props.isEdit ? { opacity: '0.5' } : null} />
                                </Button>
                            </Tooltip>
                        </span>
                        : ""

                }

                {
                    handlePermission(permissions.ItemNameImportItemName) ?
                        <span className="icon-import-file">
                            <Tooltip placement="top" title="Import Item Master">
                                <Button
                                    onClick={this.props.importFile}
                                >
                                    <img id='icon-import-amazon' src={iconImportAmazon} />
                                </Button>
                            </Tooltip>
                        </span>
                        : ""
                }


                {
                    handlePermission(permissions.ItemNameUpdateItemName) ?
                        <span className="icon add">
                            <Tooltip placement="top" title="Add item">
                                <Button
                                    className="btn-add"
                                    icon="plus"
                                    size={'small'}
                                    onClick={this.props.addNewRow}
                                />
                            </Tooltip>
                        </span>
                        : ""
                }

                {
                    handlePermission(permissions.ItemNameDeleteAllItemNames) ?
                        <span className="icon delete">
                            <Tooltip placement="top" title="Delete">
                                <Button
                                    type="button"
                                    className="button-delete"
                                    size={'small'}
                                    onClick={() => this.props.deleteItemName()}
                                    disabled={this.props.checkButtonDelete()}
                                >
                                    <img src={this.props.checkButtonDelete() ? deleteDisable : deleteEnable} />
                                </Button>
                            </Tooltip>
                        </span>
                        : ""
                }

                <span className="icon filter">
                    <Tooltip placement="top" title="Add Filter">
                        <Button
                            className={`button-filter ${this.props.isFilterVisible ? 'btn-enable' : ''}`}
                            size={'small'}
                            onClick={this.props.toggleFilter}
                        >
                            <img src={this.props.isFilterVisible ? filterEnabled : filterDisabled} />
                        </Button>
                    </Tooltip>
                </span>

                <ChannelTable
                    selectChannel={this.props.selectChannel}
                    resetCheckbox={this.props.resetCheckbox}
                    shortChannel={this.props.shortChannel}
                    isEdit={this.props.isEdit}
                    popUpConfirmSave={this.props.popUpConfirmSave}
                    checkErrorInput={this.props.checkErrorInput}
                />
                
                {
                    handlePermission(permissions.ItemNameUpdateItemName) ? 
                    <span className='icon-prohibited'>
                        <Tooltip placement="top" title="Prohibited Item Keyword Check">
                            <Button
                                className="button-prohibited"
                                onClick={this.props.onProhibitedItems}
                                disabled={LineNumberItemname === 0}
                            >
                                <img src={prohibited} />
                            </Button>
                        </Tooltip>
                    </span>
                    : ''
                }

                {
                    is_show_btn_more ?
                        <Dropdown
                            className="export-delete-panel pull-left"
                            overlay={menuImportOrder}
                            disabled={!this.props.collectIdItemCurrent.length}
                            trigger={['click']}>
                            <Button>
                                <img className='icon-more' src={iconMore} />
                            </Button>
                        </Dropdown>
                        : ""
                }

                <div className="table-header-right">
                    {this.props.collectIdItemCurrent.length ? (
                        <Pagination
                            current={this.props.pagination.currentPage}
                            total={this.props.pagination.countItemName}
                            pageSize={this.props.pagination.pageSize}
                            className='pagination-item-name'
                            onChange={(current, size) => this.props.changePagination(current, size)}
                            showLessItems
                        />
                    ) : null}
                    <Select
                        className="select-table-header-right"
                        defaultValue={this.props.pagination.pageSize}
                        value={this.props.pagination.pageSize}
                        onChange={e => this.props.onChangePageSize(e)}>
                        <Option value={10}>10</Option>
                        <Option value={20}>20</Option>
                        <Option value={50}>50</Option>
                        <Option value={100}>100</Option>
                    </Select>
                    <span className="span-table-header-right">Per Page</span>
                </div>
            </React.Fragment>
        );
    }
}

export default ToolbarItemMaster;



// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/master-maintenance/ToolbarItemMaster.js